import { render, staticRenderFns } from "./FinanceShipper.vue?vue&type=template&id=3819cf40"
import script from "./FinanceShipper.vue?vue&type=script&lang=js"
export * from "./FinanceShipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports